import { AgmCoreModule } from "@agm/core";
import { CommonModule } from "@angular/common";
import { NgModule } from "@angular/core";
import { ReactiveFormsModule } from "@angular/forms";
import { MatFormFieldModule } from "@angular/material/form-field";
import { MatIconModule } from "@angular/material/icon";
import { MatInputModule } from "@angular/material/input";
import { MatRadioModule } from "@angular/material/radio";
import { MatSelectModule } from "@angular/material/select";
import { NgbPopoverModule } from "@ng-bootstrap/ng-bootstrap";
import { TranslateModule } from "@ngx-translate/core";
import { FormFieldStateModule } from "src/app/views/pages/mad_shared/form-field-state/form-field-state.module";
import { environment } from "src/environments/environment";
import { ParcelIdentificationComponent } from "./parcel-identification.component";
import { LandAreasModule } from '../land-areas/land-areas.module'
import { NgxMaskDirective, NgxMaskPipe, provideNgxMask } from "ngx-mask";

@NgModule({
  imports: [
    CommonModule,
    ReactiveFormsModule,

    AgmCoreModule.forRoot({
        apiKey: environment.agMapKey,
        libraries: ['places', 'drawing', 'geometry']
    }),

    MatFormFieldModule,
    MatRadioModule,
    MatInputModule,
    MatSelectModule,
    MatIconModule,

    NgbPopoverModule,
    TranslateModule.forChild(),

    FormFieldStateModule,

    LandAreasModule,

    NgxMaskDirective,
    NgxMaskPipe,
  ],
  declarations: [
    ParcelIdentificationComponent
  ],
  exports: [
    ParcelIdentificationComponent
  ],
  providers: [
    provideNgxMask()
  ]
})
export class ParcelIdentificationModule {}